import { handleFreeReturn } from '@lambda/commons/helpers';
import settings from '@/settings';
import buyer from '@/public/icons/homepage/marketplace/buyer.svg';
import quality from '@/public/icons/homepage/marketplace/quality.svg';
import saving from '@/public/icons/homepage/marketplace/saving.svg';

export const countryCodePrefix = (str: string) => {
  if (str.toLocaleLowerCase() === 'us') return 'the ';

  return '';
};

const isUSStore = settings.store === 'reebelo-us';
const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

export const DEFAULT_CONTENT = {
  na: {
    title: isUSStore
      ? 'Your Marketplace for Sustainable Shopping'
      : `${settings.country}'s Marketplace for Sustainable Shopping`,
    subTitle:
      'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
    usps: [
      {
        title: 'Save Up To 70%',
        desc: 'Priced just right. Find the best deals for your favorite used and certified refurbished smartphones, laptops, gaming consoles, smartwatches, kitchen appliances, sports, fitness, baby products, and more.',
        icon: saving,
      },
      {
        title: `${freeReturnDays} Days Free Returns`,
        desc: `We guarantee satisfaction. All products are 100% functional,  professionally cleaned and inspected by industry experts at 70+ quality checkpoints.  If you change your mind, ${freeReturnDays}-day returns are on us.`,
        icon: buyer,
      },
      {
        title: `${settings.store === 'reebelo-us' ? 'Up to ' : ''} ${
          settings.warranty_month
        }-Month Warranty`,
        desc: `Buy with confidence and enjoy your purchase to the fullest with our ${
          settings.store === 'reebelo-us' ? 'up to ' : ''
        }${
          settings.warranty_month
        }-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
        icon: quality,
      },
    ],
  },
  apac: {
    title: `${settings.country}'s Marketplace for Sustainable Shopping`,
    subTitle:
      'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
    usps: [
      {
        title: 'Save Up To 70%',
        desc: 'Priced just right. Find the best deals for certified refurbished smartphones, laptops, gaming consoles, kitchen appliances, sports, fitness, baby products, and more.',
        icon: saving,
      },
      {
        title: `${freeReturnDays} Days Free Returns`,
        desc: `We guarantee satisfaction. All products are 100% functional and  professionally cleaned and inspected by industry experts at 70+ quality checkpoints.  If you change your mind, ${freeReturnDays}-day returns are on us.`,
        icon: buyer,
      },
      {
        title: `${settings.store === 'quista' ? 'Up to ' : ''}${
          settings.warranty_month
        }-Month Warranty`,
        desc: `Buy with confidence and enjoy your purchase to the fullest with ${
          settings.store === 'quista' ? 'up to ' : 'our'
        }${
          settings.warranty_month
        }-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
        icon: quality,
      },
    ],
  },
};

export const CONTENT = {
  product: {
    na: {
      electronics: {
        title: isUSStore
          ? 'Your Marketplace for Sustainable Shopping'
          : `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for your favorite used and certified refurbished smartphones, laptops, smartwatches, gaming consoles, tablets, and more.',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `We guarantee satisfaction. All devices are 100% functional and quality-checked by industry experts at 70+ checkpoints.  If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.store === 'reebelo-us' ? 'Up to ' : ''}${
              settings.warranty_month
            }-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${
              settings.store === 'reebelo-us' ? 'up to ' : ''
            }${
              settings.warranty_month
            }-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
      luxury: {
        title: isUSStore
          ? 'Your Marketplace for Sustainable Shopping'
          : `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for pre-loved luxury bags & accessories that are 100% original and authenticated by industry experts. ',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `All pre-loved bags and accessories are guaranteed authentic and are quality-checked by authenticators. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.warranty_month}-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${settings.warranty_month}-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
      fitness: {
        title: isUSStore
          ? 'Your Marketplace for Sustainable Shopping'
          : `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for pre-owned and certified refurbished fitness equipment, e-scooters & accessories. Save money while helping the environment!',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `We guarantee satisfaction. All fitness equipment and accessories are inspected and quality-checked by industry experts. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.store === 'reebelo-us' ? 'Up to ' : ''}${
              settings.warranty_month
            }-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${
              settings.store === 'reebelo-us' ? 'Up to ' : ''
            }${
              settings.warranty_month
            }-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
      home_appliances: {
        title: isUSStore
          ? 'Your Marketplace for Sustainable Shopping'
          : `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for used and certified pre-owned home appliances like blenders, coffee machines, vacuums, & more. Save money while helping the environment!',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `We guarantee satisfaction. All certified pre-owned and refurbished home appliances are 100% functional and quality-checked by industry experts. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.warranty_month}-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${settings.warranty_month}-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
    },
    apac: {
      electronics: {
        title: `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for your favorite certified refurbished smartphones, laptops, smartwatches, gaming consoles, tablets, and more.',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `We guarantee satisfaction. All devices are 100% functional and quality-checked by industry experts at 70+ checkpoints. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.store === 'quista' ? 'Up to ' : ''}${
              settings.warranty_month
            }-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with ${
              settings.store === 'quista' ? 'up to ' : 'our '
            }${
              settings.warranty_month
            }-months warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
      luxury: {
        title: `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for pre-loved luxury bags & accessories that are 100% original and authenticated by industry experts. ',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `All pre-loved luxury bags and accessories are guaranteed authentic and are quality-checked by authenticators. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.warranty_month}-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${settings.warranty_month}-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
      fitness: {
        title: `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for certified refurbished fitness equipment, e-scooters & accessories. Save money while helping the environment!',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `We guarantee satisfaction. All fitness equipment and accessories are inspected and quality-checked by industry experts. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.warranty_month}-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${settings.warranty_month}-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
      home_appliances: {
        title: `${settings.country}'s Marketplace for Sustainable Shopping`,
        subTitle:
          'Explore a wide variety of used & pre-owned smartphones, laptops, smartwatches, kitchen appliances, and more.',
        usps: [
          {
            title: 'Save Up To 70%',
            desc: 'Priced just right. Find the best deals for certified pre-owned blenders, coffee machines, vacuums, & more. Save money while helping the environment!',
            icon: saving,
          },
          {
            title: `${freeReturnDays} Day Free Returns`,
            desc: `We guarantee satisfaction. All new and refurbished home appliances are 100% functional and quality-checked by industry experts. If you change your mind, ${freeReturnDays}-day returns are on us.`,
            icon: buyer,
          },
          {
            title: `${settings.warranty_month}-Month Warranty`,
            desc: `Buy with confidence and enjoy your purchase to the fullest with our ${settings.warranty_month}-month warranty plan on all products. Expand this protection for 24 months with ReebeloCare's physical & liquid damage cover.`,
            icon: quality,
          },
        ],
      },
    },
  },
};

export const FITNESS_CATEGORIES = [
  'Sport & Fitness',
  'Beach Mat',
  'Beach Towel',
  'E-scooters',
  'E-scooters Accessories',
  'E-scooters Accessories Bundle',
  'E-skateboards',
  'Electrical Bikes',
  'Electrical Bikes Accessories',
  'Fitness',
  'Fitness Bundle',
  'Fitness Equipment',
  'Hoverboard Bundle',
  'Hoverboards',
  'Outdoor Mats',
  'Outdoor Recreation',
  'Scooters',
  'Scooters Accessories',
  'Sport & Fitness Bundle',
  'Supplements',
  'Swimwear',
  'Underwater Scooter',
  'Yoga Accessories',
  'Yoga Bundles',
  'Yoga Equipment',
  'Yoga Mats',
];

export const HOME_APPLIANCES_CATEGORIES = [
  'Vacuum Cleaners',
  'Kitchen Appliances',
  'Kitchen Tools & Utensils',
  'Blenders',
  'Mixers',
  'Toasters',
  'Air Fryers',
  'Refrigerators',
  'Microwaves',
  'Coffee Makers',
  'Toaster',
];
